import { defineRule, configure } from 'vee-validate'
import { required, email } from '@vee-validate/rules'

export default defineNuxtPlugin(() => {
    defineRule('required', required)
    defineRule('email', email)
    defineRule('phone', (value: string) => {
        if (!value) return true
        return value.length >= 12 && value.length < 13
    })

    configure({
        generateMessage: (context) => {
            const messages: Record<string, string> = {
                required: `The ${context.field} field is required.`,
                email: 'Please enter a valid email address.',
                phone: 'Please enter a valid phone number.',
            }
            return messages[context.rule?.name as string] || `The ${context.field} field is invalid.`
        },
        validateOnBlur: true,
        validateOnChange: true,
        validateOnInput: false,
        validateOnModelUpdate: true,
    })
})